import React, { useEffect, useState } from "react";
import axios from "axios";
import { FieldGroup } from "../../../../components";

const defaultCategoryId = 9;
const BrandSelect = ({ selectedBrand, setBrand, isNonMatch }) => {
  const [brands, setBrands] = useState([]);

  const fetchBrands = async () => {
    let { data } = await axios.get(
      `/api/categories/${defaultCategoryId}/brands`
    );
    if (isNonMatch) {
      data = [
        ...data,
        {
          id: "others",
          name: "Others",
        },
      ];
    }

    if (data) {
      const brandList = data.map((brand) => {
        return {
          id: brand.name,
          name: brand.name,
        };
      });
      setBrands(brandList);
    }
  };

  useEffect(() => {
    fetchBrands();
  }, []);

  return (
    <FieldGroup
      placeholder="Brand"
      type="select"
      options={brands}
      name="brand"
      noFormik
      value={selectedBrand}
      onChange={setBrand}
    />
  );
};

export default BrandSelect;
